
const IntroContentEn = () => {
    return <>
      <section className="home_banner pt-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector">
                <h2 className="poppinssemibold mb-3">
                  The private social network <br /> for your neighbourhood.
                </h2>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/images/index-banner.png"
          className="img-fluid w-100"
          alt="banner"
        />
      </section>

      <section className="known_banner">
        <div className="container">
          <div className="row">
            <div className="col-md-7"></div>
            <div
              className="col-md-5 d-flex align-items-center"
              style={{ minHeight: 660 }}
            >
              <div className="col_selector">
                <div className="known_things position-relative">
                  <img
                    src="assets/images/tick.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#F55767" }}
                    >
                      Useful
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                      The easiest way to keep up with everything in your
                      neighbourhood.
                    </p>
                  </div>
                </div>
                <div className="known_things position-relative">
                  <img
                    src="assets/images/lock.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#2563FF" }}
                    >
                      Private
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                      A private environment designed just for you and your
                      neighbours.
                    </p>
                  </div>
                </div>
                <div className="known_things position-relative">
                  <img
                    src="assets/images/proven.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#40975F" }}
                    >
                      Proven
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                      Over 127,000 neighbourhoods rely on Houmti.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="neighbours_section">
        <div className="container">
          <h2 className="text-center poppinssemibold base_color">
            When neighbours start talking, good things happen.
          </h2>
          <div className="row">
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/stronger.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#F55767" }}
                >
                  Build a stronger neighbourhood
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                  Connect with your neighbours to stay informed and share useful
                  local information.{" "}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/neighbour.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#2563FF" }}
                >
                  Keep the neighbourhood safe
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                  Look out for each other and send updates to keep the
                  neighbourhood safe.{" "}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/sharegood.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#40975F" }}
                >
                  Share goods and recommendations
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                  Find a great babysitter or trusty dentist. Borrow a ladder or
                  sell that old bookcase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
}

export default IntroContentEn;